import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.523}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8786 12887"
    {...props}
  >
    <path
      d="M8260 0H526C236 0 0 236 0 526v3978c0 291 236 526 526 526h1433l2001 2364-30 1028-1994-1292-297 268 890 638-1320 618 347 258 1320-629 1031 933-56 1935-541 780H2211v956h4453v-956H4859l-93-2129 908-649 1084 516 284-212-1083-507 731-524-243-220-1733 1018-88-1640 2305-2554h1329c291 0 526-235 526-526V526c0-290-235-526-526-526zM4020 6562 2582 5030h1485l-47 1532zm581 71 3-1603h1620L4601 6633z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
